import React, { useState } from "react";
import { Chip } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import ActionModal from "../Modals/ActionModal";

const StyledDiv = styled.div`
  gap: 8px;
`;

const SendType = ({
  recipientType,
  setRecipientType,
  recipientData,
  setRecipientData,
  isFileUploaded,
  setUploadFileData,
  uploadFileData,
  setIsFileUploaded,
  setError,
  rewardType,
  setDisabled,
  setNonScheduledAmount,
  setNonScheduleCount,
  setScheduleAmount,
  setScheduleCount,
  setGrandTotal,
  setAddMore,
  setIsEditUserEnabled,
  handleReset,
}) => {
  const [showWarning, setShowWarning] = useState(false);

  const handleClick = (recipientType, id) => {
    if (showWarning) {
      toggleTab(id);
      return;
    }
    if (recipientType === 2) {
      toggleTab(id);
      return;
    }
    if (isFileUploaded || recipientData.length) {
      setShowWarning(`${id}`);
    } else {
      toggleTab(id);
    }
  };

  const toggleTab = (id) => {
    handleReset();
    if (recipientType === 1) {
      setRecipientData([]);
      setIsEditUserEnabled(false);
      setAddMore(false);
    } else if (recipientType === 0) {
      setIsFileUploaded(false);
      setUploadFileData({
        reward_type: 2,
        skip_filename_check: 0,
        attachments: "",
      });
    }
    setError({});
    setRecipientType(id);
    setShowWarning(false);
    setDisabled(true);
    if (rewardType === 1 || rewardType === 2) {
      setNonScheduledAmount(0);
      setNonScheduleCount(0);
      setScheduleAmount(0);
      setScheduleCount(0);
    } else {
      setGrandTotal(0);
    }
  };

  const RECIPIENT_TYPE_DATA = [
    {
      id: 0,
      label: "Send in Bulk",
    },
    {
      id: 1,
      label: "Send Individually",
    },
    {
      id: 2,
      label: "Send to self",
    },
  ];

  return (
    <>
      <StyledDiv className="d-flex align-items-center px-24 pt-24 pb-12">
        {RECIPIENT_TYPE_DATA.map((item, index) => {
          if (item.id === 2 && rewardType !== 3) return null;

          return (
            <Chip
              backgroundColor={recipientType === item.id ? "primary" : "light"}
              backgroundShade={recipientType === item.id ? "c00" : "c200"}
              textColor={recipientType === item.id ? "primary" : "dark"}
              textShade={recipientType === item.id ? "c02" : "c200"}
              color="custom"
              id={item.id}
              label={item.label}
              size="medium"
              radius={20}
              onClick={(e, label, id) => {
                if (recipientType != id) handleClick(recipientType, id);
              }}
              key={index}
            />
          );
        })}
      </StyledDiv>
      {showWarning && (
        <ActionModal
          header="Are you sure?"
          actionModalSubHeader={
            "You will lose your progress if you change the recipient type. Do you want to proceed?"
          }
          callbackMethod={() => setShowWarning(false)}
          buttonText={"Yes, Proceed"}
          cancelBtnText={"No, Cancel"}
          actionHandler={() =>
            handleClick(recipientType, parseInt(showWarning))
          }
        />
      )}
    </>
  );
};

export default SendType;
